export default __webpack_public_path__ + "static/media/Dis_Payment.170e574b.svg";